let pending = null;

export function setScrollRestore(y) {
  pending = y;
}

export function consumeScrollRestore() {
  const val = pending;
  pending = null;
  return val;
}
